import { createGlobalStyle } from 'styled-components';

export const TabBarCustomStyle = createGlobalStyle`
  div[data-testid="tab-bar"] > div:first-child  {
  button {
    width: 50%;
    justify-content: center;
  }
 }
`;
